var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['checkbox', _vm.value ? 'true' : 'false', _vm.disabled ? 'disabled' : ''],on:{"click":_vm.actionTap}},[_c('i'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }